export default () => {
  const attr = 'data-circle-score';
  const items = document.querySelectorAll(`[${attr}]`);

  if (items.length === 0) return;

  items.forEach(item => {
    let score = item.getAttribute(attr);
    if (!score) return;
    const text = item.getElementsByTagName('tspan');
    const circle = item.getElementsByTagName('circle');
    text[0].textContent = score;
    /*const circleStyles = `
    stroke-dasharray: calc(100% * 3.14 * ${score} / 10) calc(100% * 3.14 * (1 - ${score} / 10));
    stroke-dashoffset: calc(100% * 3.14 * (1 + ${score} / 10) + 50%);`;
    circle[0].setAttribute('style', circleStyles);*/

    const dashArr = `${314 * score / 10}%, ${314 * (1 - score / 10)}%`;
    const dashOffset = `${314 * (1 + score / 10) + 50}%`;
    circle[0].setAttribute('stroke-dasharray', dashArr);
    circle[0].setAttribute('stroke-dashoffset', dashOffset);

    if (score.length === 1) {
      score += '.0';
    }
    text[0].innerHTML = score;

  });
}
